import AdamDodds from "./adam_dodds.jpg"
import ChrisGent from "./chris_gent.jpg"
import EdHemsworth from "./ed_hemsworth.jpg"
import JackHarrison from "./jack_harrison.jpg"
import JonCaller from "./jon_caller.jpg"
import LukeHeath from "./luke_heath.jpg"
import LukePlatkiw from "./luke_platkiw.jpg"
import MattCaller from "./matt_caller.jpg"
import OllieHarcombe from "./ollie_harcombe.jpg"
import SamVincent from "./sam_vincent.jpg"
import TaylorSmith from "./taylor_smith.jpg"
import BenWinch from "./ben_winch.jpg"
import JamesHarvey from "./james_harvey.jpg"
import OleSchack from "./ole_schack.jpg"
import OscarHemsworth from "./oscar_hemsworth.jpg"
import SebFrancois from "./seb_francois.jpg"
import BenMiddlicott from "./ben_middlicott.png"
import MichaelaghTennyson from "./michaelagh_tennyson.png"
import OliverMcguireHodge from "./oliver_mcguire-hodge.png"
import BenMillner from "./ben_millner.jpg"

export const pictures = {
    AdamDodds,
    ChrisGent,
    EdHemsworth,
    JackHarrison,
    JonCaller,
    LukeHeath,
    LukePlatkiw,
    MattCaller,
    OllieHarcombe,
    SamVincent,
    TaylorSmith,
    BenWinch,
    JamesHarvey,
    OleSchack,
    OscarHemsworth,
    SebFrancois,
    BenMiddlicott,
    MichaelaghTennyson,
    OliverMcguireHodge,
    BenMillner
}
